var map = {
	"./porcelain/bubblers.jpg": 5312,
	"./porcelain/classic_oil_lamp.jpg": 4425,
	"./porcelain/face_cups_with_legs.jpg": 7999,
	"./porcelain/flower_cups.jpg": 7216,
	"./porcelain/lady_lamp.jpg": 8830,
	"./porcelain/little_face_mugs.jpg": 8460,
	"./porcelain/oil_lamp_design_1.jpg": 6349,
	"./porcelain/oil_lamp_design_2.jpg": 6450,
	"./porcelain/small_bowls.jpg": 5428,
	"./porcelain/sun_vase.jpg": 4373,
	"./porcelain/tea_bowls.jpg": 5991,
	"./porcelain/tea_bowls_2.jpg": 8420,
	"./porcelain/tiny_vases.jpg": 7238,
	"./raku/bowls.jpg": 7956,
	"./raku/pattern_bowl.jpg": 5518,
	"./raku/potion_bottles.jpg": 1548,
	"./raku/two_faced_effigies_back.jpg": 1132,
	"./raku/two_faced_effigies_front.jpg": 4128,
	"./stoneware/blue_bowls.jpg": 5048,
	"./terra cotta/bongo.jpg": 3662,
	"./terra cotta/chimineas.jpg": 5198,
	"./terra cotta/face_pots.jpg": 5987,
	"./terra cotta/face_shot_glasses.jpg": 5758,
	"./terra cotta/giraffe.jpg": 7681,
	"./terra cotta/llama_ashtray.jpg": 1615,
	"./terra cotta/oil_lamps_lit.jpg": 1475,
	"./terra cotta/pipes.jpg": 4494,
	"./terra cotta/pot_with_plant.jpg": 2443,
	"./terra cotta/seed_pod_lamp.jpg": 9073,
	"./terra cotta/terra_cotta_creatures.jpg": 8482,
	"./terra cotta/vase.jpg": 4770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3310;